import Footer from '../Components/Footer';
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import '../Styles/UpdateIndividualRegistration.scss'
import { Link } from "react-router-dom";
import {Helmet} from "react-helmet";
import { parseISO } from "date-fns";

function UpdateIndividualRegistration() {
   const navigate = useNavigate();
   const params   = useParams()
   const [registerError, setRegisterError] = useState('')
   const [selectedRegistration, setSelectedRegistration] = useState({
      registId: '',
      guestId: '',
      eventName: '',
      registDate: '',
      spouseName: '',
      spouseBirthdate: '',
      roomType: '',
      role: '',
      buddyName: '',
      buddyBirthdate: '',
      craftType: '',
      tablesNeeded: '',
      arrivalDate: '',
      signature: '',
      signatureDate: '',
      groupId: '',
      eventId: '',
      isCCounselor: '',
      isGroupLead: '',
      isBusDrive: '',
      roomNumber: '',
      paidAdvance: '',
      amountDue: '',
      groupLead: '',
      generalNotes: ''
   });

   // Get Selected Registration
   const getRegistration = async () => {

      var registId =  params.id
      const registration = await fetch('/getselectedregistration', {
         method: 'POST',
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
            registId
        })
      })

      let registResponse = await registration.json();
      let registData =  registResponse.data.selectedRegistration[0]

      // Setting States
      setSelectedRegistration({ ...selectedRegistration,
         registId:                      registData.regist_id,
         guestId:                       registData.guest_id,
         eventName:                     registData.event_name,
         registDate:                    registData.regist_date,
         spouseName:                    registData.spouse_name,
         spouseBirthdate:               registData.spouse_birthdate,
         roomType:                      registData.room_type,
         role:                          registData.role,
         buddyName:                     registData.buddy_name,
         buddyBirthdate:                registData.buddy_birthdate,
         craftType:                     registData.craft_type,
         tablesNeeded:                  registData.tables_needed,
         arrivalDate:                   registData.arrival_date,
         signature:                     registData.signature,
         signatureDate:                 registData.signature_date,
         groupId:                       registData.group_id,
         eventId:                       registData.event_id,
         isCCounselor:                  registData.is_ccounselor,
         isGroupLead:                   registData.is_group_lead,
         isBusDrive:                    registData.is_bus_drive,
         roomNumber:                    registData.room_number,
         paidAdvance:                   registData.paid_advance,
         amountDue:                     registData.amount_due,
         groupLead:                     registData.group_lead,
         generalNotes:                  registData.general_notes
         })

   }

   const handleSubmit = async (event) => {
      try {

         var registId =  params.id
         var groupId  =  selectedRegistration.groupId;
         if(groupId == ''){
            groupId = null
         }
     
         // If Group Id is not null, check to see if it exists
         if (groupId != null){

            const groupExistsResponse = await fetch ('/getgroupid', {
               method: 'POST',
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                     groupId
                 })
               })
               const groupID = await groupExistsResponse.json()
               var groupExists = groupID.data;

               // Display error message if group does not exist
               if(groupExists == null){
                  throw new Error("Group Does Not Exist, Enter a Valid Group Code")
               }
         }

         const response2 = await fetch('/updategroupid', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               registId,
               groupId
           })
         })

         if (response2.status === 400 || response2.status === 500) {
            throw new Error("Failed User Retrieval");
         }

         let account = await response2.json();

         // Navigate to Individual Dashboard Upon Successful Registration
         navigate('/individualaccount')
      }
      catch (error) {
         setRegisterError(error.message)
      }
   }
   useEffect(() => {
      getRegistration()
   }, []);

   return ( 
      <div>
         <div className= "UpdateIndividualRegistrationContent">
            <div className= "UpdateIndividualRegistrationContainer">
               <div className="updateRegItems">
                  <div className="updateRegItemHeading">
                     Join or Leave a Group
                  </div>
                  <div className="updateRegItemsExplanation">
                     Enter a valid group code to join or remove existing code to leave group
                  </div>
                  <form>
                     <div className='groupCodeInputBar'>
                        <div>
                           <input
                              id='groupCode'
                              type='text'
                              inputmode='numeric'
                              maxlength={5}
                              value={selectedRegistration.groupId}
                              onChange={(event) => setSelectedRegistration({ ...selectedRegistration, groupId: (event.target.value)})}
                           />
                        </div>
                     </div>
                  </form>
                  <div style={{ color: 'red', margin: '10px, 0', fontFamily: 'Sen', textAlign: 'center' }}>{registerError}</div>
                  <div className='groupCodeSubmitButton'>
                     <button onClick={(event) => handleSubmit(event)}>
                        submit
                     </button>
                  </div>
               </div>
            </div>

         </div>   
      </div>
   )
};

export default UpdateIndividualRegistration;
